{
  "id": "campaign-032",
  "name": "Merry Square",
  "seed": "campaign:32",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......_.***.",
    "......_.....",
    ".b...._.....",
    "......_....T",
    "...ww._.....",
    "...ww._.....",
    ".....h_.....",
    "......_..h.,",
    "......_.h.,,",
    "..*..._....,",
    "..**.._x....",
    "..*..._.....",
    "....T._.....",
    "h..T.._.....",
    "......_.....",
    "............",
    "S..........."
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 4,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 9
    },
    {
      "kind": "rabbit",
      "x": 10,
      "y": 2
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 0,
      "y": 0
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 15
    },
    {
      "kind": "rare",
      "x": 6,
      "y": 12
    }
  ],
  "generatorVersion": 3,
  "level": 32,
  "biome": "park",
  "par": {
    "reel": 6544,
    "push": 5696,
    "selfPropelled": 5256,
    "tractor": 4920,
    "zeroTurn": 3709,
    "fairway": 2042
  },
  "routeTries": {
    "par": {
      "reel": 18,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 17
    }
  }
}
